import axios from 'axios';
import { DashboardData, SettingsUpdate } from '../types';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const fetchDashboard = async (deviceId: string = 'inkspire_001'): Promise<DashboardData> => {
  const response = await api.get(`/dashboard?device_id=${deviceId}`);
  return response.data;
};

export const updateSettings = async (
  deviceId: string,
  settings: SettingsUpdate
): Promise<{ status: string; message: string }> => {
  const response = await api.put(`/settings/${deviceId}`, settings);
  return response.data;
};

export const sendSummaryNow = async (
  deviceId: string
): Promise<{ status: string; message: string }> => {
  const response = await api.post(`/send-summary/${deviceId}`);
  return response.data;
};

export default api;
